module.exports = __webpack_public_path__ + "img/DollarIcon.52e01b6c.jpg";